export default __webpack_public_path__ + "static/cup-55aa0ccfa5933dbc2135c4f7edfe17b6.svg";